var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// helpers
import { parseJwt } from '@/helpers/login';
import { readFromLocalStorage } from '@/helpers/storage';
// api
import { initiateRefreshToken } from '@/includes/api/auth';
// constants
import Routes from '@/constants/Routes';
import { LOGIN_TYPE } from '@/constants/login';
import { localStorageKeys } from '@/constants/storage';
export function refreshTokenHelper(cb) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const jwtToken = yield readFromLocalStorage(localStorageKeys.ACCESS_TOKEN);
            const refreshToken = yield readFromLocalStorage(localStorageKeys.REFRESH_TOKEN);
            if (!jwtToken || !refreshToken) {
                throw new Error('No token found');
            }
            const tokenDetails = parseJwt(jwtToken);
            yield initiateRefreshToken(tokenDetails.sub, refreshToken);
        }
        catch (e) {
            if (__DEV__) {
                console.error(e);
            }
            const loginType = yield readFromLocalStorage(localStorageKeys.LOGIN_TYPE);
            if (loginType && loginType === LOGIN_TYPE.INTERNAL) {
                cb(Routes.EMPLOYEE_LOGIN);
            }
            else {
                cb(Routes.EXTERNAL_LOGIN);
            }
        }
    });
}
